// extracted by mini-css-extract-plugin
export default {"recordViewer":"Qv1LZfrKM82_6lwN35hU__recordViewer___"};